import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import classes from '../UnitEconomics.module.css';

const ARR = props => {
	const { mrrMensual, mrrAnual, mrrMensualAnterior, mrrAnualAnterior, isLoading } = props;
	const [monthYear, setMonthYear] = useState('');
	const [booleanMayor, setBooleanMayor] = useState(false);

	const formatDate = dateToTransform => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	useEffect(() => {
		const updateHook = async () => {
			if (mrrMensual.mrr !== '' && mrrAnual.mrrPlanAnual !== '' && mrrMensualAnterior.mrr !== '' && mrrAnualAnterior !== '') {
				if (mrrMensual.mrr + mrrAnual.mrrPlanAnual > mrrMensualAnterior.mrr + mrrAnualAnterior) {
					setBooleanMayor(true);
				} else {
					setBooleanMayor(false);
				}
			}
		};
		updateHook();
	}, [mrrMensual, mrrAnual, mrrMensualAnterior, mrrAnualAnterior, booleanMayor]);

	useEffect(() => {
		if (isLoading === false) {
			setMonthYear(formatDate(mrrMensual.dateFrom));
		}
	}, [isLoading, mrrMensual.dateFrom]);

	return (
		<React.Fragment>
			<div className={classes.helpTipContainer}>
				<div className={classes.headerTitle}>ARR</div>
			</div>
			<div className={classes.date}>{monthYear}</div>
			{isLoading ? (
				<CircularProgress />
			) : (
				<div>
					<div className={classes.number}>
						<NumberFormat
							value={(mrrMensual.mrr + mrrAnual.mrrPlanAnual) * 12}
							displayType={'text'}
							thousandSeparator={true}
							prefix={'US$'}
							decimalScale={0}
						/>
					</div>
					{/* {booleanMayor ? (
						<FontAwesomeIcon className={classes.faArrowDown} icon={faArrowDown} />
					) : (
						<FontAwesomeIcon className={classes.faArrowUp} icon={faArrowUp} />
					)} */}
				</div>
			)}
		</React.Fragment>
	);
};

export default React.memo(ARR);
